export const isDarkMode = () => {
  return isBodyDarkMode() || isClassDarkMode() || isMediaDarkMode();
}

function isBodyDarkMode() {
  return document.body.classList.contains('dark');
}

function isClassDarkMode() {
  return document.documentElement.classList.contains('dark');
}

function isMediaDarkMode() {
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
}
